<template>
  <generic-in-app-screen>
    <b-container class="flex-grow-1 d-flex flex-column">
      <h1 class="my-5">
        <b>{{ $t('project_import') }}</b>
      </h1>

      <b-alert :show="alert_text !== ''" variant="warning">{{
        $t('alert_text')
      }}</b-alert>
      &nbsp;

      <b-card :header="$t('decrypt_imported_project')" class="mt-4">
        <b-form-group>
          <label>
            <b> {{ $t('enter_zip_passphrase') }} </b>
          </label>
          <b-form-input
            v-model="passphrase"
            :placeholder="$t('enter_zip_passphrase')"
          />
        </b-form-group>
      </b-card>

      <b-card :header="$t('upload_from_local_client')" class="mt-4">
        <file-uploader
          :project_id="project_id"
          :disabled="currently_importing"
          @success="import_from_uploaded($event)"
        />
      </b-card>

      <b-card :header="$t('load_from_distant_server')" class="mt-4">
        <filepath-selector
          v-model="import_file"
          class="mt-3"
          :placeholder="$t('selected_import_file')"
          :is_open="true"
        />

        <b-button
          block
          variant="outline-secondary"
          class="mt-3"
          :disabled="disabled_import"
          @click="import_project"
        >
          {{ $t('import_project') }}
        </b-button>
      </b-card>
    </b-container>
  </generic-in-app-screen>
</template>

<style scoped>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
</style>

<i18n>
{
  "en": {
    "project_import": "Importing a project",
    "decrypt_imported_project": "Decrypt imported project",
    "enter_zip_passphrase": "Passphrase to decrypt the import file",    
    "selected_import_file": "Selected import file :",
    "import_project": "Import the selected project",
    "upload_from_local_client": "Upload from local browser / client",
    "load_from_distant_server": "Load from distant server",
    "cwra_invalid_project_decryption_password": "The entered passphrase is incorrect for imported project",
    "cwra_failed_to_import_project": "Failed to import project"
  },
  "fr": {
    "project_import": "Import d'un projet",
    "decrypt_imported_project": "Déchiffrer le projet importé",
    "enter_zip_passphrase": "Mot de passe pour déchiffrer le fichier d'import",
    "selected_import_file": "Fichier du projet à importer :",
    "import_project": "Import du projet sélectionné",
    "upload_from_local_client": "Envoyer depuis le navigateur / client local",
    "load_from_distant_server": "Charger depuis le serveur distant",
    "cwra_invalid_project_decryption_password": "Le mot de passe entré est incorrect pour le fichier sélectionné",
    "cwra_failed_to_import_project": "Le projet n'a pas pu être importé"
  }
}
</i18n>

<script>
import _ from 'lodash'

import { subscription_mixin, project_mixin } from '@/components/mixin.js'

import {
  import_project,
  import_project_from_uploaded_file,
} from '@/api/subscriptions.js'
import { GenericPath, unserializer } from '@/components/object_model.js'

import FilepathSelector from '@/components/filepath_selector.vue'
import FileUploader from '@/components/file_uploader.vue'
import GenericInAppScreen from '@/components/generic_in_app_screen.vue'

export default {
  name: 'ProjectImport',
  components: {
    FilepathSelector,
    FileUploader,
    GenericInAppScreen,
  },
  mixins: [subscription_mixin, project_mixin],
  data() {
    return {
      import_file: new GenericPath(),
      passphrase: '',
      currently_importing: false,
      alert_text: '',
    }
  },
  computed: {
    disabled_import() {
      // N.B PL : Don't know if it's possible to know when the export is finished and ready ?
      return _.isEqual(this.import_file.path, '') || this.currently_importing
    },
    workflow_path() {
      let route = this.$route.path
      let route_splitted = route.split('/')
      let n = route_splitted.length
      route_splitted[n - 1] = 'workflow'
      let res = route_splitted.join('/')
      return res
    },
    // project_id() {
    //   let route = this.$route.path
    //   let regexp = new RegExp('(\\d)*/import')
    //   let regexp_match = route.match(regexp)[0].split('/')
    //   let res = Number(regexp_match[0])
    //   return res
    // },
    // ...mapGetters(['automl_rawfiles_undeleted_object_per_project']),
  },
  beforeMount() {
    this.fetch_collections([
      'projects',
      'bricks',
      'connectors',
      'users',
      'project_rights',
    ])
  },
  methods: {
    async import_project() {
      // N.B PL : For now we just suppose the path never contain
      // metavariables, will need to be changed later
      try {
        if (!_.isEqual(this.import_file.path, '')) {
          this.currently_importing = true
          this.alert_text = ''
          this.invalid_file = false
          await import_project(
            this.project_id,
            this.import_file.path,
            this.passphrase
          )
          this.$router.push(this.workflow_path)
        }
      } catch (err) {
        let terr = unserializer.visit(err.response.data)
        this.alert_text = this.$t(terr.args[0])
      } finally {
        this.currently_importing = false
      }
    },
    async import_from_uploaded(token) {
      try {
        this.currently_importing = true
        this.alert_text = ''
        this.invalid_file = false
        await import_project_from_uploaded_file(
          this.project_id,
          token,
          this.passphrase
        )
        this.$router.push(this.workflow_path)
      } catch (err) {
        let terr = unserializer.visit(err.response.data)
        this.alert_text = this.$t(terr.args[0])
      } finally {
        this.currently_importing = false
      }
    },
  },
}
</script>
